'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

const VisibleVersionContext = createContext();

export const VisibleVersionProvider = ({ children }) => {
  const [visibleVersion, setVisibleVersion] = useState(null);
  const [topThreshold, setTopThreshold] = useState(0);

  useEffect(() => {
    // Get the computed scroll-padding-top from CSS
    const computedStyle = getComputedStyle(document.documentElement);
    const scrollPaddingTop = parseInt(computedStyle.getPropertyValue('scroll-padding-top'), 10);
    setTopThreshold(scrollPaddingTop);

    const handleScroll = () => {
      const elements = document.querySelectorAll('[data-visible-id]');
      let activeElement = null;
      let firstElement = elements[0];

      for (const element of elements) {
        const rect = element.getBoundingClientRect();
        const isElementActive = rect.top <= topThreshold + 1;

        if (isElementActive) {
          activeElement = element;
        } else {
          break; // Stop checking once we find the first element that is not active
        }
      }

      // If no element meets the top threshold, check if the first element is above half the viewport
      if (!activeElement && firstElement) {
        const rect = firstElement.getBoundingClientRect();
        const isElementAboveHalfViewport = rect.top < window.innerHeight / 2;

        if (isElementAboveHalfViewport) {
          activeElement = firstElement;
        }
      }

      setVisibleVersion(activeElement ? activeElement.dataset.visibleId : null);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call to set the first visible version

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [topThreshold]);

  return <VisibleVersionContext.Provider value={{ visibleVersion }}>{children}</VisibleVersionContext.Provider>;
};

export const useVisibleVersion = () => {
  return useContext(VisibleVersionContext);
};
